import authAPI from '~/api/AuthAPI';
import { updateProductCartStore } from '../CartProductAction';
import { updateComboServiceCartStore } from '../CartComboServiceAction';
import { GET_PROFILE, LOGIN, LOGOUT, UPDATE_PROFILE } from './type';

export const handleLogout = (onSuccess = (success = false) => {}) => {
    return async (dispatch) => {
        try {
            // const cartProduct = JSON.parse(localStorage.getItem('cartProduct'));
            localStorage.clear();
            // localStorage.setItem('cartProduct', JSON.stringify([...cartProduct]));
            // localStorage.removeItem('userInfo');
            // localStorage.removeItem('token');
            // localStorage.removeItem('cartProduct');
            // localStorage.removeItem('cartComboService');
            // localStorage.removeItem('listProductOrder');
            // localStorage.removeItem('totalPriceProductOrder');
            // localStorage.removeItem('comboServiceOrder');
            // localStorage.removeItem('totalPriceComboServiceOrder');
            // localStorage.removeItem('phone_booking');
            // localStorage.removeItem('activeKeyHistoryOrder');
            // localStorage.removeItem('activeKeyHistoryBooking');
            // localStorage.removeItem('navigateAfterLogin');
            dispatch(updateProductCartStore([]));
            // dispatch(updateComboServiceCartStore([]));
            dispatch({
                type: LOGOUT,
            });
            onSuccess(true);
        } catch (err) {
            onSuccess(false);
            console.log(err);
        }
    };
};

export const handleLogin = (data, onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.loginAPI(data);
            const userInfo = res?.results?.object?.result;
            const token = res?.results?.object?.token;
            const refreshToken = res?.results?.object?.refreshToken;
            dispatch({
                type: LOGIN,
                payload: userInfo,
            });
            localStorage.removeItem('phone_booking');
            localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
            localStorage.setItem('token', JSON.stringify(token));
            localStorage.setItem('refreshToken', refreshToken);
            onSuccess(true);
        } catch (err) {
            console.log('log action', err);
            onSuccess(false);
            onError(err);
        }
    };
};

export const handleLoginOTP = (data, onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.loginOTP(data);
            const userInfo = res?.results?.object?.result;
            const token = res?.results?.object?.token;
            const refreshToken = res?.results?.object?.refreshToken;
            dispatch({
                type: LOGIN,
                payload: userInfo,
            });
            localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
            localStorage.setItem('token', JSON.stringify(token));
            localStorage.setItem('refreshToken', refreshToken);
            onSuccess(true);
        } catch (err) {
            onSuccess(false);
            onError(err);
        }
    };
};

export const loginPhoneNumber = (data, onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.loginWithPhone(data);
            const userInfo = res?.results?.object?.result;
            const token = res?.results?.object?.token;
            const refreshToken = res?.results?.object?.refreshToken;
            dispatch({
                type: LOGIN,
                payload: userInfo,
            });
            localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
            localStorage.setItem('token', JSON.stringify(token || ''));
            localStorage.setItem('refreshToken', refreshToken);
            onSuccess(true);
        } catch (err) {
            onSuccess(false);
            onError(err);
        }
    };
};

export const getInfoProfile = (onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.getProfileAPI();
            const userInfo = res?.results?.object;

            dispatch({
                type: GET_PROFILE,
                payload: userInfo,
            });

            localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
            onSuccess(true);
            return res;
        } catch (err) {
            onSuccess(false);
            onError(err);
            return err;
        }
    };
};

export const updateInfoProfile = (data, onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.updateProfileAPI(data);
            const userInfo = res?.results?.object;
            // userInfo.birthday = '10-10-2022';
            dispatch({
                type: UPDATE_PROFILE,
                payload: userInfo,
            });

            localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
            onSuccess(true);
        } catch (err) {
            onSuccess(false);
            onError(err);
        }
    };
};

export const handleRefreshToken = (data, onSuccess = (success = false) => {}, onError = (error = '') => {}) => {
    return async (dispatch, getState) => {
        try {
            const res = await authAPI.refreshToken(data);

            const token = res?.results?.object?.token;
            const refreshToken = res?.results?.object?.refreshToken;

            localStorage.setItem('token', JSON.stringify(token));
            localStorage.setItem('refreshToken', refreshToken);
            onSuccess(true);
            return res;
        } catch (err) {
            onSuccess(false);
            onError(err);
            return err;
        }
    };
};
